// src/api/guiaApi.js
//
// Cliente de /api/holaveci/guia/* — endpoints accesibles con rol GUIA.
// Todos los endpoints retornan datos del Guia dueño del token.

import { api, API_BASE_URL, tokenStorage, ApiError } from './apiClient';

const BASE = '/api/holaveci/guia';

// Mensaje amigable por defecto para errores HTTP en el uploader.
// apiClient no exporta su version helper — replicamos lo minimo aca.
const msgHttp = (status, backendMsg) =>
  backendMsg ||
  (status === 401 ? 'Tu sesión expiró. Vuelve a iniciar sesión.' :
   status === 403 ? 'No tienes permiso para esta operación.' :
   status === 404 ? 'Recurso no encontrado.' :
   status === 413 ? 'El archivo es demasiado grande.' :
   status >= 500 ? 'Error del servidor. Intenta de nuevo.' :
   `Error ${status}.`);

export const guia = {
  perfil:       () => api.get(`${BASE}/perfil`),
  panel:        () => api.get(`${BASE}/panel`),
  afiliados:    () => api.get(`${BASE}/afiliados`),
  comisiones:   (filtros = {}) => api.get(`${BASE}/comisiones`, { query: filtros }),
  liquidaciones: () => api.get(`${BASE}/liquidaciones`),
  detalleLiquidacion: (id) => api.get(`${BASE}/liquidaciones/${id}`),

  /**
   * Cambia la contraseña propia. Requiere la actual como prueba de posesión.
   * @param {string} passwordActual
   * @param {string} passwordNuevo
   */
  cambiarPassword: (passwordActual, passwordNuevo) =>
    api.post(`${BASE}/perfil/cambiar-password`, { passwordActual, passwordNuevo }),

  /**
   * Sube o cambia la foto propia. Es multipart, va por fetch directo
   * porque apiClient siempre serializa como JSON.
   * @param {File} file
   * @returns {Promise<{ url: string }>}
   */
  cambiarFoto: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const token = tokenStorage.get();
    let response;
    try {
      response = await fetch(`${API_BASE_URL}${BASE}/perfil/foto`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
    } catch (err) {
      throw new ApiError({
        statusCode: 0,
        message: err.message || 'network error',
        mensajeUsuario: 'No se pudo conectar al servidor. Revisa tu conexión e inténtalo de nuevo.',
      });
    }
    const text = await response.text();
    let data = null;
    if (text) { try { data = JSON.parse(text); } catch { data = text; } }
    if (!response.ok) {
      const backendMessage = data?.mensaje || data?.message || (typeof data === 'string' ? data : null);
      throw new ApiError({
        statusCode:     response.status,
        message:        backendMessage || `HTTP ${response.status}`,
        mensajeUsuario: msgHttp(response.status, backendMessage),
      });
    }
    return data;
  },
};
